import { SECTION_CARD } from '@/components/ui/section-card-variants'
import Skeleton from '@/components/ui/Skeleton'
import { cn } from '@/lib/utils'

/**
 * `VerifiedCertificateCard`'s own shape: the status pill, the course title,
 * three fact rows (`KeyValueList`'s hairline rows, `py-2` here). Light on
 * purpose — this is the PUBLIC route's own pending component, so it ships in
 * the entry chunk the same as any signed-in route's (docs/route-loading.md).
 */
export default function VerifyCertificateSkeleton() {
  return (
    <div aria-hidden="true" className={cn(SECTION_CARD, 'flex flex-col gap-4')}>
      <Skeleton className="h-6 w-24 rounded-full" />
      {/* Figma 22 → h-6 (4-grid tie, non-interactive). */}
      <div className="flex h-6 items-center">
        <Skeleton className="h-5 w-2/3 rounded-xs" />
      </div>
      <div className="flex flex-col divide-y divide-border-subtle">
        {['Holder', 'Issued', 'Code'].map((label) => (
          <div key={label} className="flex items-center justify-between gap-4 py-2">
            <Skeleton className="h-4 w-16 rounded-xs" />
            <Skeleton className="h-4 w-28 rounded-xs" />
          </div>
        ))}
      </div>
    </div>
  )
}
